export const deviceState = {
    启用: '5f1bba6b-0875-13fc-c7f3-53e8369bce78',
    禁用: 'dd9b0030-8c01-f6a3-d14e-57df88a66264',
    报废: '342c112f-c346-ee25-5305-d9b7dcdf0253'
}